import { getCookie } from "../../utils/cookie";
var ua = typeof window === 'undefined' ? '' : window.navigator.userAgent;
export var getUA = function getUA() {
  return ua;
};
export var getClientType = function getClientType() {
  var browserType = '';
  if (ua.match(/(Opera|OPR)/)) {
    browserType = 'Opera';
  } else if (ua.match(/Firefox/)) {
    browserType = 'Firefox';
  } else if (ua.match(/Chrome/)) {
    browserType = 'Chrome';
  } else if (ua.match(/Safari/)) {
    browserType = 'Safari';
  } else if (ua.match(/Trident/)) {
    browserType = 'IE';
  } else if (ua.match(/Edge/)) {
    browserType = 'Edge';
  }

  // console.log('browserType', browserType);
  return browserType;
};
export var getOS = function getOS() {
  var system = '未知操作系统';
  if (ua.indexOf('Windows') >= 0) {
    system = 'Windows';
  } else if (ua.indexOf('Mac') >= 0) {
    system = 'Mac';
  } else if (ua.indexOf('X11') >= 0) {
    system = 'Unix';
  } else if (ua.indexOf('Android') >= 0) {
    system = 'Android';
  } else if (ua.indexOf('iPhone') >= 0) {
    system = 'iPhone';
  }
  return system;
};
export var getOsVersion = function getOsVersion() {
  var version = '';
  if (ua.indexOf('Mac OS X') > -1) {
    // mac
    var regStr_saf = /OS X [\d._]*/gi;
    var verinfo = ua.match(regStr_saf);
    version = (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
  } else if (ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1) {
    // andr
    version = ua.substr(ua.indexOf('Android') + 8, ua.indexOf(';', ua.indexOf('Android')) - ua.indexOf('Android') - 8);
  } else {
    // windows
    var userAgent = ua.toLowerCase();
    if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
      version = 'Windows XP';
    } else if (userAgent.indexOf('windows nt 6.0') > -1) {
      version = 'Windows Vista';
    } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
      version = 'Windows 7';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
      version = 'Windows 8';
    } else if (userAgent.indexOf('windows nt 6.3') > -1) {
      version = 'Windows 8.1';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
      version = 'Windows 10';
    } else {
      version = 'Unknown';
    }
  }
  return version;
};
export var getPageType = function getPageType() {
  var needMergeRoute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  try {
    // 项目名称 等价于 hostname， 页面即 pathname+hash
    var _window$location = window.location,
      hostname = _window$location.hostname,
      pathname = _window$location.pathname,
      hash = _window$location.hash;
    var _path = '';
    var _hash = '';
    if (pathname === '/') {
      _path = '';
    } else {
      _path = pathname.replaceAll('--', '__');
    }
    if (hash) {
      // 去掉 hash 中的 ? 参数
      _hash = hash.replace(/\?.*/, '').replace(/^#\//, '');

      // 合并动态 :id 路由
      try {
        console.log('needMergeRoute', needMergeRoute);
        if (needMergeRoute) {
          _hash = _hash.split('/').map(function (v) {
            return v.replace(/^[0-9a-zA-Z]{18,}$/, ':id').replace(/^[0-9]{1,}$/, ':id').replace('undefined', ':id');
          }).join('/');
        }
      } catch (error) {}
    }
    // 限制字段长度
    var p = "".concat(hostname, "--").concat(_path).concat(_hash).slice(0, 200);
    return p;
  } catch (e) {
    return '';
  }
};
export var getPageUrl = function getPageUrl() {
  try {
    var _window$location2 = window.location,
      protocol = _window$location2.protocol,
      hostname = _window$location2.hostname,
      pathname = _window$location2.pathname,
      hash = _window$location2.hash;
    var url = "".concat(protocol, "//").concat(hostname).concat(pathname).concat(hash && hash.split('?')[0]);
    return url;
  } catch (e) {
    return '';
  }
};

/**
 * 获取用户 uid
 */
export var getCookieId = function getCookieId() {
  return getCookie('sso_uid') || getCookie('idzz') || getCookie('id58') || '';
};

// 获取浏览器 timeOrigin
export var getBrowserTimeOrigin = function getBrowserTimeOrigin() {
  var _window, _window$performance;
  if (!((_window = window) !== null && _window !== void 0 && (_window$performance = _window.performance) !== null && _window$performance !== void 0 && _window$performance.now)) return;
  var performance = window.performance;
  var timeOrigin = performance.timeOrigin ? performance.timeOrigin : performance.timing.navigationStart;
  return timeOrigin;
};
export var fix = function fix(t) {
  return Math.min(1e5, Math.max(parseInt(t === null || t === void 0 ? void 0 : t.toString(), 10) || 0, 0));
};
export var waitTime = function waitTime() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (res) {
    return setTimeout(res, time);
  });
};
export var setStorage = function setStorage(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // 满了就清空，避免影响业务
    window.localStorage.removeItem(key);
  }
};
export var getStorage = function getStorage(key) {
  try {
    window.localStorage.getItem(key);
  } catch (error) {}
};
export var removeStorage = function removeStorage(key) {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {}
};